import { SUPPORT_EMAIL } from './general'

export const REQUEST_TYPE_CREATE = 'CREATE'
export const REQUEST_TYPE_DELETE = 'DELETE'
export const REQUEST_TYPE_DOWNLOAD = 'DOWNLOAD'
export const REQUEST_TYPE_FETCH = 'FETCH'
export const REQUEST_TYPE_UPDATE = 'UPDATE'
export const REQUEST_TYPE_UPLOAD = 'UPLOAD'
export const REQUEST_TYPE_SEND = 'SEND'

export const ERROR_MESSAGE_UNKNOWN = 'Unknown error occurred, try reloading the page'
export const ERROR_MESSAGE_AUTHENTICATION = 'Authentication error'
export const ERROR_MESSAGE_UNAUTHORISED = 'Unauthorised, try reloading the page'
export const ERROR_MESSAGE_GENERIC = `An error occurred while attempting the request, please contact ${SUPPORT_EMAIL}`
export const ERROR_MESSAGE_SAVING = 'There was a problem with saving the data'
export const ERROR_MESSAGE_DELETING = 'There was a problem with deleting the data'
export const ERROR_MESSAGE_DELETING_FILE = 'There was a problem with deleting the file'
export const ERROR_MESSAGE_UPLOADING_FILE = 'There was a problem uploading the file'
export const ERROR_MESSAGE_DOWNLOADING_FILE = `There was a problem downloading the file, please contact ${SUPPORT_EMAIL}`
export const ERROR_MESSAGE_NO_RESULTS = 'No results found'

export const REQUEST_ERROR_MESSAGES = {
    [REQUEST_TYPE_CREATE]: ERROR_MESSAGE_SAVING,
    [REQUEST_TYPE_DELETE]: ERROR_MESSAGE_DELETING,
    [REQUEST_TYPE_DOWNLOAD]: ERROR_MESSAGE_DOWNLOADING_FILE,
    [REQUEST_TYPE_FETCH]: ERROR_MESSAGE_GENERIC,
    [REQUEST_TYPE_UPDATE]: ERROR_MESSAGE_SAVING,
    [REQUEST_TYPE_UPLOAD]: ERROR_MESSAGE_UPLOADING_FILE,
    [REQUEST_TYPE_SEND]: ERROR_MESSAGE_GENERIC,
}

export const SUCCESS_MESSAGE_CREATE = 'Successfully created'
export const SUCCESS_MESSAGE_DELETE = 'Successfully deleted'
export const SUCCESS_MESSAGE_UPDATE = 'Successfully saved'
export const SUCCESS_MESSAGE_SEND = 'Successfully sent'

export const REQUEST_SUCCESS_MESSAGES = {
    [REQUEST_TYPE_CREATE]: SUCCESS_MESSAGE_CREATE,
    [REQUEST_TYPE_DELETE]: SUCCESS_MESSAGE_DELETE,
    [REQUEST_TYPE_UPDATE]: SUCCESS_MESSAGE_UPDATE,
    [REQUEST_TYPE_SEND]: SUCCESS_MESSAGE_SEND,
}
